import React from "react";
import { View, Text, StyleSheet, Platform } from "react-native";

// For Android or iOS, use SelectDropdown
// For Web, use Picker
import SelectDropdown from 'react-native-select-dropdown';
import { Picker } from '@react-native-picker/picker';

const PaymentMethodsElement = ({ paymentMethods, currentPayment, setCurrentPayment }) => {

    console.log("Payment methods: ", paymentMethods);

    if (Platform.OS !== 'web') {
        /*
        * Use this for Android or iOS build
        */
        return (
            <SelectDropdown
                dropdownStyle={styles.listStyle}
                rowStyle={styles.rowStyle}
                rowTextStyle={styles.rowTextStyle}
                buttonTextStyle={styles.buttonTextStyle}
                data={paymentMethods}
                defaultButtonText={"Selecione a forma de pagamento"}
                onSelect={(selectedItem, index) => {
                    console.log(selectedItem.name, index);
                    setCurrentPayment(selectedItem);
                }}
                buttonTextAfterSelection={(selectedItem, index) => {
                    // text represented after item is selected
                    // if data array is an array of objects then return selectedItem.property to render after item is selected
                    return selectedItem.name;
                }}
                rowTextForSelection={(selectedItem, index) => {
                    // text represented for each item in dropdown
                    // if data array is an array of objects then return item.property to represent item in dropdown
                    return selectedItem.name;
                }}
            />
        );
    } else {
        /*
        * Use this for Web build
        */
        return (
            <Picker
                style={styles.picker}
                itemStyle={styles.picker}
                selectedValue={currentPayment.id}
                onValueChange={(itemValue, itemIndex) => {
                    console.log("PaymentMethod: ", itemValue);
                    setCurrentPayment(paymentMethods[itemIndex-1]);
                }
            }>
                <Picker.Item label={"Selecione uma forma de pagamento"} value={"0"} enabled={false}/>
                {paymentMethods.map((paymentMethod) => {
                    return <Picker.Item label={paymentMethod.name} value={paymentMethod.id}/>
                })}
            </Picker>
        );
    }
};

const styles = StyleSheet.create({
    picker: {
        borderColor: '#F0A22E',
        borderWidth: 1,
        backgroundColor: 'white',
        fontSize: 16,
        padding: 10,
        borderRadius: 10,
    },
    listStyle: {
        backgroundColor: 'white',
        width: 500
    },
    rowStyle: {
    },
    rowTextStyle: {
    },
    buttonTextStyle: {
        padding: 10,
        flexGrow: 1,
        backgroundColor: 'white',
        borderColor: '#F0A22E',
        borderWidth: 1,
        borderRadius: 10
    }
  });

export default PaymentMethodsElement;